module.exports = __webpack_public_path__ + "static/process_capability_and_assessment-95194727b6fb147709a9422ea57e006d.jpg";